<script lang="ts">
    import { lightenColor } from "@ui-utils/lightenColor";

    import type { RewardsStorefrontValuesBrandingEntity } from "../entities/entities";

    //Props
    export let rewardsBrandingGeneral: RewardsStorefrontValuesBrandingEntity["general"];

    //Variables
    const { theme, buttons, content } = rewardsBrandingGeneral;
</script>

<div
    class="rewards-general-theme"
    style:--gw-rd-theme__primary-color={theme.primaryColor}
    style:--gw-rd-theme__secondary-color={theme.secondaryColor}
    style:--gw-rd-primary-button__theme-color={theme[buttons.themeColor]}
    style:--gw-rd-primary-button__theme-highlight-color={lightenColor(
        theme[buttons.themeColor],
        5
    )}
    style:--gw-rd-secondary-button__theme-color={theme[buttons.themeColor]}
    style:--gw-rd-secondary-button__theme-highlight-color={"var(--gw-rd-button-bg-color)"}
    style:--gw-rd-buttons__font-color={buttons.fontColor}
    style:--gw-rd-content__icons-theme-color={theme[content.iconsThemeColor]}
    style:--gw-rd-content__links-theme-color={theme[content.linksThemeColor]}
>
    <slot />
</div>

<style lang="postcss">
    .rewards-general-theme {
        height: 100%;
    }
</style>
